import React, { useState, useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import Body from "./Components/Body/Body";
import Contact from "./Components/Contact Us/Contact";
import Preloader from "./Components/Preloader/Preloader";
import Fintech from "./Components/Pages/Industries/Fintech/Fintech";
import RealEstate from "./Components/Pages/Industries/Real Estate/RealEstate";
import Banking from "./Components/Pages/Industries/Banking/Banking";
import Pharma from "./Components/Pages/Industries/Pharma/Pharma";
import HealthCare from "./Components/Pages/Industries/HealthCare/HealthCare";
import Welfare from "./Components/Pages/Industries/Welfare/Welfare";
import Art from "./Components/Pages/Industries/Art/Art";
import Insaurance from "./Components/Pages/Industries/Insurance/Insurance";
import Government from "./Components/Pages/Industries/Government/Government";
import Entertainment from "./Components/Pages/Industries/Entertainment/Entertainment";
import Gaming from "./Components/Pages/Industries/Gaming/Gaming";
import Presentation from "./Components/Pages/Investers/Presentation/Presentation";
import Financials from "./Components/Pages/Investers/Financials/Financials";
import AnnualReport from "./Components/Pages/Investers/Annual Report/AnnualReport";
import CompanyAnnouncement from "./Components/Pages/Investers/CompanyAnnouncements/CompanyAnnouncements";
import CorporateGovernance from "./Components/Pages/Investers/Corporate Governance/CorporateGovernance";
import ShareholdingPattern from "./Components/Pages/Investers/Shareholding Pattern/ShareholdingPattern";
import MarketTracker from "./Components/Pages/Investers/Market Tracker/MarketTracker";
import InvesterForm from "./Components/Pages/Investers/Inverter Form/InvesterForm";
import TechnologyPractices from "./Components/Pages/Services/Technology Practices/TechnologyPractices";
import DigitalCommerce from "./Components/Pages/Services/Digital Commerce/DigitalCommerce";
import SoftwareProducts from "./Components/Pages/Services/Software Products/SoftwareProducts";
import DevSecOps from "./Components/Pages/Services/DevSecOps/DevSecOps";
import DigitalQualityAssurance from "./Components/Pages/Services/Digital Quality Assurance/DigitalQualityAssurance";
import Offering from "./Components/Pages/Services/Offering/Offering";
import GenerativeAi from "./Components/Pages/Services/Generative Ai/GenerativeAi";
import CxInfrastructure from "./Components/Pages/Services/CX Infrastructure/CxInfrastructure";
import IntelligentAutomation from "./Components/Pages/Services/Intelligent Automation/IntelligentAutomation";
import Training from "./Components/Pages/Services/Training/Training";
import PrivateEquity from "./Components/Pages/Services/Private Equity/PrivateEquity";
import PrivateEquityServices from "./Components/Pages/Services/Private Equity Service/PrivateEquityService";
import EnterpriseIntegrations from "./Components/Pages/Services/Enterprise Integrations/EnterpriseIntegrations";
import EnterpriseSecurity from "./Components/Pages/Services/Enterprise Security/EnterpriseSecurity";
import DataAnalysis from "./Components/Pages/Services/Data and Analytics/DataAnalytics";
import Mobile from "./Components/Pages/Services/Mobile/Mobile";
import SentCv from "./Components/Pages/Careers/SentCv/SentCv";
import CurrentOpenPosition from "./Components/Pages/Careers/Current Open Position/CurrentOpenPosition";
import WhyJoinUs from "./Components/Pages/Careers/Why Join Us/WhyJoinUs";
import EmployeeTestimonials from "./Components/Pages/Careers/Employee Testimonials/EmployeeTestimonials";
import About from "./Components/Pages/Company/About/About";
import CorporateValue from "./Components/Pages/Company/Corporate Value/CorporateValue";
import News from "./Components/Pages/Company/News/News";
import HealthTech from "./Components/Pages/Company/Health Tech/HealthTech";
import RetailsManufacturing from "./Components/Pages/Company/Retails Manufacturing/RetailsManufacturing";
import ToolTechStack from "./Components/Pages/Tool Tech Stack/ToolTechStack";
import Blog from "./Components/Pages/Resources/Blog/Blog";
import Energy from "./Components/Pages/Industries/Energy/Energy";
import CloudInfrastructure from "./Components/Pages/Services/Cloud Infrastructure/CloudInfrastructure";
import ApplicationDevelopment from "./Components/Pages/Services/Application Development/ApplicationDevelopment";
import Internship from "./Components/Pages/Careers/Internship Program/Internship";
import Gallery from "./Components/Pages/Company/Gallery/Gallery";

const AppWrapper = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time (you can replace this with actual loading logic)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {isLoading && <Preloader />}
      {!isLoading && children}
    </>
  );
};

const RouteLayout = ({ children }) => {
  // Remove the loading state from RouteLayout
  return <>{children}</>;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Body /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },
  {
    path: "/home",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Body /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },
  {
    path: "/contact-us",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Contact /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/fintech",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Fintech /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/real-estate",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <RealEstate /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/banking",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Banking /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/pharma",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Pharma /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/health-care",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <HealthCare /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

    {
    path: "/welfare",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Welfare /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

      {
    path: "/art",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Art /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

        {
    path: "/insurance",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Insaurance /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

          {
    path: "/government",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Government /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/entertainment",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Entertainment /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

    {
    path: "/gaming",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Gaming /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

      {
    path: "/energy",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Energy /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

      {
    path: "/blog",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Blog /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

        {
    path: "/presentations",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Presentation /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },
         {
    path: "/financials",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Financials /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/annual-reports",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <AnnualReport /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },
  {
    path: "/company-announcements",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <CompanyAnnouncement /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

    {
    path: "/corporate-governance",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <CorporateGovernance /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },
      {
    path: "/shareholding-pattern",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <ShareholdingPattern /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

   {
    path: "/Market-tracker",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <MarketTracker /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

     {
    path: "/investor-form/information",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <InvesterForm /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/investor-contact-details",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <InvesterForm /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/technology-practices",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <TechnologyPractices /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

    {
    path: "/digital-commerce",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <DigitalCommerce /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/software-product",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <SoftwareProducts /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/cloud-infrastructure",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <CloudInfrastructure /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },
  {
    path: "/dev-sec-ops",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <DevSecOps /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/digital-quality-assurance",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <DigitalQualityAssurance /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/offering",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Offering /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/generative-ai",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <GenerativeAi /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/cx-infrastructure",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <CxInfrastructure /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/intelligent-automation",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <IntelligentAutomation /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/application-development-management",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <ApplicationDevelopment /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/training",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Training /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/private-equity",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <PrivateEquity /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/private-equity-services",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <PrivateEquityServices /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/enterprise-integration",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <EnterpriseIntegrations /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/enterprise-it-security",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <EnterpriseSecurity /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/data-analytics",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <DataAnalysis /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/mobile",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Mobile /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/send-cv",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <SentCv /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

    {
    path: "/internship-program",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Internship /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/current-open-position",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <CurrentOpenPosition /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/why-join-us",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <WhyJoinUs /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/employee-testimonials",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <EmployeeTestimonials /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/about",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <About /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/corporate-value",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <CorporateValue /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

{
    path: "/news",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <News /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

{
    path: "/health-tech",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <HealthTech /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/retails-manufacturing",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <RetailsManufacturing /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

    {
    path: "/gallery",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <Gallery /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },

  {
    path: "/tools-tech-stack",
    element: (
      <AppWrapper>
        <RouteLayout>
          <Header /> <ToolTechStack /> <Footer />
        </RouteLayout>
      </AppWrapper>
    ),
  },





]);

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
